<template>
  <v-card>
    <v-card-title>{{ $t('cookies.settings_title') }}</v-card-title>
    <v-card-text>
      <div v-html="$t('cookies.settings_text')"></div>
      <div class="d-flex mt-8 mb-2">
        <div class="subtitle-1">{{ $t('cookies.strictly_necessary') }}</div>
        <v-spacer/>
        <div class="subtitle-1 primary--text">{{ $t('cookies.always_active') }}</div>
      </div>
      <div>{{ $t('cookies.strictly_necessary_description') }}</div>
      <div class="d-flex mt-8 mb-2">
        <div class="subtitle-1">{{ $t('cookies.performance') }}</div>
        <v-spacer/>
        <v-switch v-model="performance" color="primary" inset hide-details class="mt-0"/>
      </div>
      <div>{{ $t('cookies.performance_description') }}</div>
      <div class="d-flex mt-8 mb-2">
        <div class="subtitle-1">{{ $t('cookies.functionality') }}</div>
        <v-spacer/>
        <v-switch v-model="functional" color="primary" inset hide-details class="mt-0"/>
      </div>
      <div>{{ $t('cookies.functionality_description') }}</div>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="primary" @click="saveSettings()">{{ $t('save')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import cookieconsent from '@/js/cookieconsent'

export default {
  name: "CookieSettings",
  data() {
    return {
      performance: false,
      functional: false,
    }
  },
  methods: {
    saveSettings() {
      cookieconsent.setPerformance(this.performance);
      cookieconsent.setFunctional(this.functional);
      cookieconsent.setConsentAccepted();
      this.$emit("updated");
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cookies/CookieSettings.vue